import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {DescriptionModule} from '../description/description.module'
import {ThanksYouPageComponent} from './thanks-you-page.component'
import {FooterModule} from '../footer/footer.module'

@NgModule({
  imports: [
    CommonModule,
    DescriptionModule,
    FooterModule
  ],
  declarations: [ThanksYouPageComponent],
  exports: [
    ThanksYouPageComponent
  ]
})
export class ThanksYouPageModule {
}
